import { Intersect } from "./intersect/index";
export default (Vue) => {
  Vue.directive(`intersection`, {
    inserted: Intersect.inserted,
    beforeMount: Intersect.inserted,
  });
};
